import { createAsyncThunk } from '@reduxjs/toolkit';
import sanitizeHtml from 'sanitize-html';
import { Modals } from '../modals/types';
import { SubscribeGiftPromoCodeParams } from '../../api/types/SubscribeGiftPromoCodeParams';
import { showModal } from '../modals/modalsSlice';
import getMessageFromCode from './getMessageFromCode';
import api from '../../api/api';
import { Error, KEY_STORAGE_PROMOCODE } from '../../const';
import auth from '../auth/utils/mym';
import { EventCat, EventGTM, EventId, EventName, trackEventBound } from '../../utils/ga';

// Thunk Actions
const subscribeGiftPromoCode = createAsyncThunk(
  'subscribeGiftPromoCode/create',
  // eslint-disable-next-line consistent-return
  async (params: SubscribeGiftPromoCodeParams, { dispatch, rejectWithValue }) => {
    dispatch(showModal({ modalType: Modals.Loading, modalProps: {} }));
    try {
      const response = await api.subscribeGiftPromoCode(params);

      if (response.data.code === 200) {
        dispatch(
          showModal({
            modalType: Modals.SubscriptionApi,
            modalProps: {
              ...getMessageFromCode(200),
            },
          })
        );
        sessionStorage.removeItem(KEY_STORAGE_PROMOCODE);

        trackEventBound(
          EventGTM.MakeConversions,
          EventId.SubscriptionGiftActivateSuccess,
          EventCat.Gift,
          EventName.SubmitTransaction,
          'Промокод активирован'
        );

        return response.data;
      }

      dispatch(
        showModal({
          modalType: Modals.SubscriptionApi,
          modalProps: getMessageFromCode(response.data.code),
        })
      );

      const htmlMessage = `${getMessageFromCode(response.data.code).title} ${
        getMessageFromCode(response.data.code).message
      } / #${response.data.code}`;

      trackEventBound(
        EventGTM.MakeConversions,
        EventId.SubscriptionGiftActivateFailure,
        EventCat.Gift,
        EventName.SendError,
        `Активировать / ${sanitizeHtml(htmlMessage, {
          allowedTags: [],
          allowedAttributes: {},
        })}`
      );
    } catch (error) {
      if (error.response && error.response.status === Error.UNAUTHORIZED) {
        auth.authOTP();
      } else {
        dispatch(
          showModal({
            modalType: Modals.SubscriptionApi,
            modalProps: getMessageFromCode(500),
          })
        );

        const status =
          error.response && error.response.status ? ` / #${error.response.status}` : '';

        trackEventBound(
          EventGTM.MakeConversions,
          EventId.SubscriptionGiftFailure,
          EventCat.Gift,
          EventName.SendError,
          `Активировать / Ошибка подключения${status}`
        );
      }

      return rejectWithValue(error);
    }
  }
);

export default subscribeGiftPromoCode;
